import React, { useState, useEffect } from 'react';
import request from 'superagent';

import GOOGLE_ACCOUNTS_LIB from 'shared-constants/src/googleOneTapLib';

import loadScript from 'shared-utils/src/loadScript';
// import manageSigninData from 'shared-utils/src/manageSigninData';
// import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import { getItem } from 'shared-utils/src/localStorage';

const GoogleOneTapComponent = ({
  dataClienId = '216935561144-poj31for12ebj4jeao1qv1it7j0ncpnt.apps.googleusercontent.com',
  dataLoginUri = 'https://casa.it/client-account/api/v1/social',
  loginMethod = null,
  display = false,
  // isHp = false,
} = {}) => {
  const [hasGAccountsLib, setHasGAccountsLib] = useState(false);
  const [validLastLogin, setValidLastLogin] = useState(false);
  // const [isUp, setIsUp] = useState(false);

  useEffect(async () => {
    const signinData = getItem('signinData') || { lastSession: { email: '', lastLoginMedium: '' } };
    const { lastSession: { email, lastLoginMedium } } = signinData;
    const isValid = (!email && !lastLoginMedium) || email.indexOf('@gmail') > -1 || lastLoginMedium === 'google' || lastLoginMedium === 'googleonetap';
    setValidLastLogin(isValid);
    
    const script = document.querySelector(`script[src="${GOOGLE_ACCOUNTS_LIB}"]`);
    if (!script) {
      const a = await loadScript(GOOGLE_ACCOUNTS_LIB);
      setHasGAccountsLib(a.type === 'load' && window.google?.accounts);
    } else if (window.google?.accounts) {
      setHasGAccountsLib(true);
    } else {
      console.log(':: script già caricato ma window.google.accounts assente ::');
    }
  }, []);

  useEffect(() => {
    if (hasGAccountsLib) {

      const handleCredentialResponse = async (response) => {   
        
        const { credential, select_by } = response;

        const gotResp = await request.post(`${dataLoginUri}/googleSignin/`)
          .set('Content-Type', 'application/json')
          .set('Accept', 'application/json')
          .send({ credential, from: select_by });

        if (gotResp.status === 200) {
          const loginData = {
            isGoogleOneTap: true,
            ...gotResp.body,
          }
          loginMethod(null, loginData);

        }
      };

      const logPromptNotification = (notification) => {
        // if (notification.isDisplayed()) {
        //   setIsUp(true);
        //   manageSigninData({ trackOneTapPrompt: true });
        // } else if (notification.isDismissedMoment()) {
        //   trackGTMEvents({
        //     category: 'Interaction',
        //     action: 'GOT_Dismissed',
        //     label: notification.getDismissedReason(),
        //   });
        // }
      };

      if (display && validLastLogin) {
        window.google.accounts.id.initialize({
          client_id: dataClienId,
          callback: handleCredentialResponse,
          auto_select: true,
          // prompt_parent_id: 'csa_one_tap',
          state_cookie_domain: 'casa.it',
        });
        window.google.accounts.id.prompt(logPromptNotification);
      }
      //  else if (isUp) {
      //   setIsUp(false);
      //   window.google.accounts.id.cancel(); 
      // }
    }
  }, [hasGAccountsLib, validLastLogin, display]);

  // return <div id="csa_one_tap" />;
  return null;
};

export default GoogleOneTapComponent;
